import { useEffect } from 'react';

export function useOutsideClick(
  refs: Array<React.RefObject<HTMLElement>>,
  handler: (e: MouseEvent) => void
) {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const target = e.target as Node;
      for (const r of refs) {
        if (!r?.current) continue;
        if (r.current.contains(target)) return;
      }
      handler(e);
    };

    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [refs, handler]);
}

export default useOutsideClick;
